import { ConfiguratorOptions, DEPENDENCIES } from '@empathybroker/ebx-gluon';
import { CdlProductPageService } from '../../config/services/cdl-product-page-service.service';

export function rebindContainer({ container }: ConfiguratorOptions) {
  container.rebind(DEPENDENCIES.ProductPageService).to(CdlProductPageService);
}
